import { APIClient } from "api/api_helper";
import { designApiService } from "../../modules/Library/Design/api/design.api";
import { LIBRARY_API, Sponsor_API , BedManagement_API} from "api/url_helper";
import { CurrentUser, GetUserData, showToastMessage } from "common/service/CommonService";


const api = new APIClient();

//---------------------------------------------------------------------------------------
// Types
//---------------------------------------------------------------------------------------

export interface CommonOption {
    value: number | string;
    label: string;
    createddate?: string;
}

//---------------------------------------------------------------------------------------
// Label Resolver
//---------------------------------------------------------------------------------------

export const getLabelFromValue = (
    options: CommonOption[],
    value?: number | string | null,
    emptyText = "—"
): string => {
    if (value === undefined || value === null) return emptyText;
    const numericValue = typeof value === "string" ? parseInt(value, 10) : value;
    return options.find(opt => opt.value === numericValue)?.label ?? emptyText;
};

//---------------------------------------------------------------------------------------
// Public Option Arrays
//---------------------------------------------------------------------------------------

export const Country_OPTIONS: CommonOption[] = [];
export const MedicalCode_OPTIONS: CommonOption[] = [];
export const BloodGroup_OPTIONS: CommonOption[] = [];
export const IDPROOF_OPTIONS: CommonOption[] = [];
export const MaritalStatus_OPTIONS: CommonOption[] = [];
export const Ethnicity_OPTIONS: CommonOption[] = [];
export const Religion_OPTIONS: CommonOption[] = [];
export const Occupation_OPTIONS: CommonOption[] = [];
export const EducationLevel_OPTIONS: CommonOption[] = [];
export const PrimaryLanguage_OPTIONS: CommonOption[] = [];
export const FoodHabit_OPTIONS: CommonOption[] = [];
export const PopulationGroup_OPTIONS: CommonOption[] = [];
export const LiterateStatus_OPTIONS: CommonOption[] = [];
export const Race_OPTIONS: CommonOption[] = [];
export const AlcoholResult_OPTIONS: CommonOption[] = [];
export const Attachment_OPTIONS: CommonOption[] = [];
export const IcfChecklistAnswer_OPTIONS: CommonOption[] = [];
export const StudyPhase_OPTIONS: CommonOption[] = [];
export const StudyType_OPTIONS: CommonOption[] = [];
export const TherapeuticArea_OPTIONS: CommonOption[] = [];
export const StudyStatus_OPTIONS: CommonOption[] = [];
export const StudyDesign_OPTIONS: CommonOption[] = [];
export const Gender_OPTIONS: CommonOption[] = [];
export const Biological_matrix_OPTIONS: CommonOption[] = [];
export const Routeof_Administration_OPTIONS: CommonOption[] = [];
export const Light_Condition_OPTIONS: CommonOption[] = [];
export const Anticoagulant_OPTIONS: CommonOption[] = [];
export const Fasting_Condition_OPTIONS: CommonOption[] = [];
export const SPONSOR_NAME_OPTIONS: CommonOption[] = [];
export const SEQUENCE_NUMBER_OPTIONS: CommonOption[] = [];
export const SMOKING_OPTIONS: CommonOption[] = [];
export const Checklist_Type_OPTIONS: CommonOption[] = [];
export const AE_STATUS_OPTIONS: CommonOption[] = [];
export const AE_SEVERITY_OPTIONS: CommonOption[] = [];
export const AE_CAUSALITY_OPTIONS: CommonOption[] = [];
export const AE_ACTION_TAKEN_OPTIONS: CommonOption[] = [];
export const AE_REPORT_METHOD_OPTIONS: CommonOption[] = [];
export const AE_OCCURRENCE_OPTIONS: CommonOption[] = [];
export const AE_OUTCOME_OPTIONS: CommonOption[] = [];
export const AE_LIKELIHOOD_OPTIONS: CommonOption[] = [];
export const AE_RELATIONSHIP_OPTIONS: CommonOption[] = [];
export const AE_PERIOD_OPTIONS: CommonOption[] = [];
export const AE_DIAGNOSIS_OPTIONS: CommonOption[] = [];
// ── IP Inventory Options ──────────────────────────────────────────
export const IP_DOSAGE_FORM_OPTIONS: CommonOption[] = [];
export const IP_STORAGE_CONDITION_OPTIONS: CommonOption[] = [];
export const IP_BLINDING_STATUS_OPTIONS: CommonOption[] = [];
export const IP_STATUS_OPTIONS: CommonOption[] = [];
export const IP_UNIT_OPTIONS: CommonOption[] = [];
export const IP_CATEGORY_OPTIONS: CommonOption[] = [];
export const IP_PHYSICAL_CONDITION_OPTIONS: CommonOption[] = [];
export const IP_TEMP_LOGGER_STATUS_OPTIONS: CommonOption[] = [];
export const IP_RETURN_SOURCE_TYPE_OPTIONS: CommonOption[] = [];
export const IP_RETURN_REASON_OPTIONS: CommonOption[] = [];
export const IP_TOTAL_CONTAINERS_OPTIONS: CommonOption[] = [];
export const REASON_FOR_REPRINT_OPTIONS: CommonOption[] = [];
export const RETENTION_TYPE_OPTIONS: CommonOption[] = [];
export const MANUFACTURER_LABEL_OPTIONS: CommonOption[] = [];
export const MODE_OF_RECEIPT_OPTIONS: CommonOption[] = [];
export const PACKING_CONDITION_OPTIONS: CommonOption[] = [];
export const DOSING_FORM_OPTIONS: CommonOption[] = [];
export const CONTAINER_CONDITION_OPTIONS: CommonOption[] = [];
// ── Disposal Options ──────────────────────────────────────────
export const DISPOSAL_REASON_OPTIONS: CommonOption[] = [];
export const DISPOSAL_METHOD_OPTIONS: CommonOption[] = [];
export const DISPOSAL_LOCATION_OPTIONS: CommonOption[] = [];
// ── Transfer Options ──────────────────────────────────────────
export const TRANSFER_TYPE_OPTIONS: CommonOption[] = [];
export const TRANSFER_ATTACHMENT_OPTIONS: CommonOption[] = [];
// ── Block Volunteer Options ──────────────────────────────────────────
export const BLOCK_REASONS_OPTIONS: CommonOption[] = [];
// ── Dropout Volunteer Options ──────────────────────────────────────────
export const DROPOUT_TYPE_OPTIONS: CommonOption[] = [];
export const DROPOUT_REASONS_OPTIONS: CommonOption[] = [];
export const WITHDRAWAL_REASONS_OPTIONS: CommonOption[] = [];
// ── transfer Volunteer Options ──────────────────────────────────────────
export const VOLUNTEER_TRANSFER_TYPE_OPTIONS: CommonOption[] = [];
export const VOLUNTEER_TRANSFER_REASON_OPTIONS: CommonOption[] = [];

//Ambulatory Visits options
export const AMBULATORY_VISIT_TYPE_OPTIONS: CommonOption[] = [];
export const AMBULATORY_VISIT_CATEGORY_OPTIONS: CommonOption[] = [];
export const AMBULATORY_VISIT_ACTIVITY_CATEGORY_OPTIONS: CommonOption[] = [];

// CRF ASSIGNMENT MODULE OPTIONS
export const CRF_ASSIGNMENT_MODULES_NAME_OPTIONS: CommonOption[] = [];
export const COLLECTION_SKIP_REASON_OPTIONS: CommonOption[] = [];
export const BLOOD_COLLECTION_REMARKS_OPTIONS: CommonOption[] = [];
export const CHECKLIST_CATEGORY_OPTIONS: CommonOption[] = [];
export const DEVIATION_REASONS_OPTIONS: CommonOption[] = [];

// Box Module options
export const BOX_TYPE_OPTIONS: CommonOption[] = [];
export const BOX_SIZE_OPTIONS: CommonOption[] = [];
export const APPLICABLE_ALIQUOT_TYPE_OPTIONS: CommonOption[] = [];
export const STORAGE_CONDITION_OPTIONS: CommonOption[] = [];


export const ROOM_TYPE_OPTIONS: CommonOption[] = [];
export const BED_TYPE_OPTIONS: CommonOption[] = [];
//---------------------------------------------------------------------------------------
// Mapping
//---------------------------------------------------------------------------------------

const CODELIST_MAP = {
    Country_OPTIONS: { code: "gender", target: Country_OPTIONS },
    MedicalCode_OPTIONS: { code: "selection(Yes/No)", target: MedicalCode_OPTIONS },
    BloodGroup_OPTIONS: { code: "bloodGroup", target: BloodGroup_OPTIONS },
    IDPROOF_OPTIONS: { code: "IDT", target: IDPROOF_OPTIONS },
    MaritalStatus_OPTIONS: { code: "maritalStatus", target: MaritalStatus_OPTIONS },
    Ethnicity_OPTIONS: { code: "ethnicity", target: Ethnicity_OPTIONS },
    Religion_OPTIONS: { code: "religion", target: Religion_OPTIONS },
    Occupation_OPTIONS: { code: "occupation", target: Occupation_OPTIONS },
    EducationLevel_OPTIONS: { code: "educationLevel", target: EducationLevel_OPTIONS },
    PrimaryLanguage_OPTIONS: { code: "primaryLanguage", target: PrimaryLanguage_OPTIONS },
    FoodHabit_OPTIONS: { code: "foodHabit", target: FoodHabit_OPTIONS },
    PopulationGroup_OPTIONS: { code: "populationGroup", target: PopulationGroup_OPTIONS },
    LiterateStatus_OPTIONS: { code: "literateStatus", target: LiterateStatus_OPTIONS },
    Race_OPTIONS: { code: "race", target: Race_OPTIONS },
    AlcoholResult_OPTIONS: { code: "alcoholResult", target: AlcoholResult_OPTIONS },
    Attachment_OPTIONS: { code: "attachment", target: Attachment_OPTIONS },
    IcfChecklistAnswer_OPTIONS: { code: "icfChecklistAnswer", target: IcfChecklistAnswer_OPTIONS },
    StudyPhase_OPTIONS: { code: "studyPhase", target: StudyPhase_OPTIONS },
    StudyType_OPTIONS: { code: "studyType", target: StudyType_OPTIONS },
    TherapeuticArea_OPTIONS: { code: "therapeuticArea", target: TherapeuticArea_OPTIONS },
    StudyStatus_OPTIONS: { code: "studyStatus", target: StudyStatus_OPTIONS },
    StudyDesign_OPTIONS: { code: "studyDesign", target: StudyDesign_OPTIONS },
    Gender_OPTIONS: { code: "gender", target: Gender_OPTIONS },
    Biological_matrix_OPTIONS: { code: "biologicalMatrix", target: Biological_matrix_OPTIONS },
    Routeof_Administration_OPTIONS: { code: "routeofAdministration", target: Routeof_Administration_OPTIONS },
    Light_Condition_OPTIONS: { code: "lightCondition", target: Light_Condition_OPTIONS },
    Anticoagulant_OPTIONS: { code: "anticoagulant", target: Anticoagulant_OPTIONS },
    Fasting_Condition_OPTIONS: { code: "fastingCondition", target: Fasting_Condition_OPTIONS },
    SEQUENCE_NUMBER_OPTIONS: { code: "sequenceNumber", target: SEQUENCE_NUMBER_OPTIONS },
    SMOKING_OPTIONS: { code: "smoking", target: SMOKING_OPTIONS },
    Checklist_Type_OPTIONS: { code: "checklistType", target: Checklist_Type_OPTIONS },
    AE_STATUS_OPTIONS: { code: "adverseeventStatus", target: AE_STATUS_OPTIONS },
    AE_SEVERITY_OPTIONS: { code: "severityGrade", target: AE_SEVERITY_OPTIONS },
    AE_CAUSALITY_OPTIONS: { code: "casuality", target: AE_CAUSALITY_OPTIONS },
    AE_ACTION_TAKEN_OPTIONS: { code: "actionTaken", target: AE_ACTION_TAKEN_OPTIONS },
    AE_REPORT_METHOD_OPTIONS: { code: "reportMethod", target: AE_REPORT_METHOD_OPTIONS },
    AE_OCCURRENCE_OPTIONS: { code: "occurrence", target: AE_OCCURRENCE_OPTIONS },
    AE_OUTCOME_OPTIONS: { code: "outcome", target: AE_OUTCOME_OPTIONS },
    AE_LIKELIHOOD_OPTIONS: { code: "likelihood", target: AE_LIKELIHOOD_OPTIONS },
    AE_RELATIONSHIP_OPTIONS: { code: "relationship", target: AE_RELATIONSHIP_OPTIONS },
    AE_PERIOD_OPTIONS: { code: "period", target: AE_PERIOD_OPTIONS },
    AE_DIAGNOSIS_OPTIONS: { code: "diagnosis", target: AE_DIAGNOSIS_OPTIONS },
    IP_STORAGE_CONDITION_OPTIONS: { code: "requiredStorageCondition", target: IP_STORAGE_CONDITION_OPTIONS },
    IP_UNIT_OPTIONS: { code: "receiveUnit", target: IP_UNIT_OPTIONS },
    IP_PHYSICAL_CONDITION_OPTIONS: { code: "physicalCondition", target: IP_PHYSICAL_CONDITION_OPTIONS },
    IP_TEMP_LOGGER_STATUS_OPTIONS: { code: "transitTempLoggerStatus", target: IP_TEMP_LOGGER_STATUS_OPTIONS },
    IP_CATEGORY_OPTIONS: { code: "ipCategory", target: IP_CATEGORY_OPTIONS },
    IP_RETURN_SOURCE_TYPE_OPTIONS: { code: "returnSourceType", target: IP_RETURN_SOURCE_TYPE_OPTIONS },
    IP_RETURN_REASON_OPTIONS: { code: "returnForReason", target: IP_RETURN_REASON_OPTIONS },
    IP_TOTAL_CONTAINERS_OPTIONS: { code: "ipTotalContainers", target: IP_TOTAL_CONTAINERS_OPTIONS },
    REASON_FOR_REPRINT_OPTIONS: { code: "reasonForReprint", target: REASON_FOR_REPRINT_OPTIONS },
    RETENTION_TYPE_OPTIONS: { code: "retentiontype", target: RETENTION_TYPE_OPTIONS },
    MANUFACTURER_LABEL_OPTIONS: { code: "manufacturelabel", target: MANUFACTURER_LABEL_OPTIONS },
    MODE_OF_RECEIPT_OPTIONS: { code: "modeofreceipt", target: MODE_OF_RECEIPT_OPTIONS },
    PACKING_CONDITION_OPTIONS: { code: "packingcondition", target: PACKING_CONDITION_OPTIONS },
    DOSING_FORM_OPTIONS: { code: "dosageform", target: DOSING_FORM_OPTIONS },
    CONTAINER_CONDITION_OPTIONS: { code: "containercondition", target: CONTAINER_CONDITION_OPTIONS },
    DISPOSAL_REASON_OPTIONS: { code: "disposalreason", target: DISPOSAL_REASON_OPTIONS },
    DISPOSAL_METHOD_OPTIONS: { code: "disposalmethod", target: DISPOSAL_METHOD_OPTIONS },
    DISPOSAL_LOCATION_OPTIONS: { code: "disposallocation", target: DISPOSAL_LOCATION_OPTIONS },
    TRANSFER_TYPE_OPTIONS: { code: "transfertype", target: TRANSFER_TYPE_OPTIONS },
    TRANSFER_ATTACHMENT_OPTIONS: { code: "transferattachment", target: TRANSFER_ATTACHMENT_OPTIONS },
    BLOCK_REASONS_OPTIONS: { code: "blockreason", target: BLOCK_REASONS_OPTIONS },
    DROPOUT_TYPE_OPTIONS: { code: "dropouttype", target: DROPOUT_TYPE_OPTIONS },
    DROPOUT_REASONS_OPTIONS: { code: "dropoutreason", target: DROPOUT_REASONS_OPTIONS },
    VOLUNTEER_TRANSFER_TYPE_OPTIONS: { code: "volunteertransfertype", target: VOLUNTEER_TRANSFER_TYPE_OPTIONS },
    VOLUNTEER_TRANSFER_REASON_OPTIONS: { code: "volunteertransferreason", target: VOLUNTEER_TRANSFER_REASON_OPTIONS },
    AMBULATORY_VISIT_TYPE_OPTIONS: { code: "visittype", target: AMBULATORY_VISIT_TYPE_OPTIONS },
    AMBULATORY_VISIT_CATEGORY_OPTIONS: { code: "visitcategory", target: AMBULATORY_VISIT_CATEGORY_OPTIONS },
    AMBULATORY_VISIT_ACTIVITY_CATEGORY_OPTIONS: { code: "activitycategory", target: AMBULATORY_VISIT_ACTIVITY_CATEGORY_OPTIONS },
    CRF_ASSIGNMENT_MODULES_NAME_OPTIONS: { code: "crfModules", target: CRF_ASSIGNMENT_MODULES_NAME_OPTIONS },
    CHECKLIST_CATEGORY_OPTIONS: { code: "checklistCategory", target: CHECKLIST_CATEGORY_OPTIONS },
    DEVIATION_REASONS_OPTIONS: { code: "deviationReasons", target: DEVIATION_REASONS_OPTIONS },
    COLLECTION_SKIP_REASON_OPTIONS: { code: "sampleCollectionSkipReason", target: COLLECTION_SKIP_REASON_OPTIONS },
    BLOOD_COLLECTION_REMARKS_OPTIONS: { code: "sampleCollectionRemarks", target: BLOOD_COLLECTION_REMARKS_OPTIONS },
    BOX_TYPE_OPTIONS: { code: "boxtype", target: BOX_TYPE_OPTIONS },
    BOX_SIZE_OPTIONS: { code: "boxsize", target: BOX_SIZE_OPTIONS },
    APPLICABLE_ALIQUOT_TYPE_OPTIONS: { code: "applicablealiquottype", target: APPLICABLE_ALIQUOT_TYPE_OPTIONS },
    STORAGE_CONDITION_OPTIONS: { code: "storagecondition", target: STORAGE_CONDITION_OPTIONS },
    ROOM_TYPE_OPTIONS: { code: "roomtype", target: ROOM_TYPE_OPTIONS },
    BED_TYPE_OPTIONS: { code: "bedtype", target: BED_TYPE_OPTIONS },
    WITHDRAWAL_REASONS_OPTIONS: { code: "withdrawalreason", target: WITHDRAWAL_REASONS_OPTIONS },
} as const;

//---------------------------------------------------------------------------------------
// Load ONLY REQUIRED CodeLists 
//---------------------------------------------------------------------------------------

export const loadCodelists = async (
    keys: (keyof typeof CODELIST_MAP)[]
): Promise<Record<string, boolean>> => {
    const results: Record<string, boolean> = {};
    const codelistCodes = keys.map(key => CODELIST_MAP[key].code).join(",");
    try {
        const res = await api.create(LIBRARY_API.CODELIST_API + "Dropdown", { codelistcode: codelistCodes });
        const list = res?.data ?? [];
        if (!Array.isArray(list)) {
            keys.forEach(key => {
                results[key] = false;
            });
            return results;
        }

        keys.forEach(key => {
            const { code, target } = CODELIST_MAP[key];
            const options: CommonOption[] = list
                .filter((item: any) => item.codelistcode === code)
                .map((item: any) => ({
                    value: Number(item.codelistdetailid),
                    label: String(item.codelistname),
                    createddate: item.createddate,
                }));
            target.splice(0, target.length, ...options);
            results[key] = true;
        });

    } catch (err) {
        keys.forEach(key => { results[key] = false; });
    }

    return results;
};

export const loadCodelistsDetailId = async (
    keys: (keyof typeof CODELIST_MAP)[]
): Promise<Record<string, boolean>> => {
    const results: Record<string, boolean> = {};
    const codelistCodes = keys.map(key => CODELIST_MAP[key].code).join(",");
    try {
        const res = await api.create(LIBRARY_API.CODELIST_API + "Dropdown", { codelistcode: codelistCodes });
        const list = res?.data ?? [];
        if (!Array.isArray(list)) {
            keys.forEach(key => {
                results[key] = false;
            });
            return results;
        }

        keys.forEach(key => {
            const { code, target } = CODELIST_MAP[key];
            const options: CommonOption[] = list
                .filter((item: any) => item.codelistcode === code)
                .map((item: any) => ({
                    value: Number(item.codelistdetailid),
                    label: String(item.codelistname),
                    createddate: item.createddate,
                }));
            target.splice(0, target.length, ...options);
            results[key] = true;
        });

    } catch (err) {
        keys.forEach(key => { results[key] = false; });
    }

    return results;
};



export const loadSponsors = async () => {
    try {
        const user = GetUserData() as CurrentUser;
        const res = await api.create(Sponsor_API.Sponsor_API + "SelectAll",
            {
                status: "A",

                config_db: "STD",
                ispagination: false
            }
        );
        const list = res?.data ?? [];

        if (!Array.isArray(list)) return;

        const options: CommonOption[] = list.map((item: any) => ({
            value: String(item.sponsorname),
            label: String(item.sponsorname),
            data: item,
        }));

        SPONSOR_NAME_OPTIONS.splice(0, SPONSOR_NAME_OPTIONS.length, ...options);

        return list;

    } catch (error) {
        showToastMessage("error", "Error in loading sponsors");
    }
};

export const loadStudyDesign = async () => {
    try {
        const res = await designApiService.selectAllData("", 1, 1000);
        const list = res?.data ?? [];

        if (!Array.isArray(list)) return;

        const options: CommonOption[] = list.map((item: any) => ({
            value: Number(item.studydesignid),
            label: String(item.designtitle),
            data: item,
        }));

        StudyDesign_OPTIONS.splice(0, StudyDesign_OPTIONS.length, ...options);

        return list;
    } catch (error) {
        showToastMessage("error", "Error in loading study designs");
    }
};
